import { InvoiceDisplayStatusV2 } from 'anchor-scout-common/types';
export const SHARED_RECEIPT_ELIGIBLE_STATUSES = new Set([
    InvoiceDisplayStatusV2.Paid
]);
